var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.updateExists)?_c('b-button',{attrs:{"block":"","variant":"warning"},on:{"click":_vm.refreshApp}},[_vm._v("\n    New version available; please refresh\n  ")]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }